import React from 'react';
import './index.scss';

import discord from '@op/assets/svg/channel/discord.svg';
import facebook from '@op/assets/svg/channel/facebook.svg';
import facebookGaming from '@op/assets/svg/channel/facebook_gaming.svg';
import youtube from '@op/assets/svg/channel/youtube.svg';
import twitter from '@op/assets/svg/channel/twitter.svg';

import metacritic from '@op/assets/svg/channel/metacritic.svg';
import opencritic from '@op/assets/svg/channel/opencritic.svg';
import steam from '@op/assets/svg/channel/steam.svg';
import chzzk from '@op/assets/svg/channel/chzzk.svg';
import sooplive from '@op/assets/svg/channel/sooplive.svg';

import app_store from '@op/assets/svg/channel/app_store.svg';
import google_play from '@op/assets/svg/channel/google_play.svg';
import taptap from '@op/assets/svg/channel/taptap.svg';

import epgame from '@op/assets/svg/channel/epgame.svg';
import twitch from '@op/assets/svg/channel/twitch.svg';
import vgtime from '@op/assets/svg/channel/vgtime.svg';
import reddit from '@op/assets/svg/channel/reddit.svg';
import youtube_gaming from '@op/assets/svg/channel/youtube_gaming.svg';
import tiktok from '@op/assets/svg/channel/tiktok.svg';
import douyin from '@op/assets/svg/channel/douyin.svg';
import vk from '@op/assets/svg/channel/vk.svg';
import cafe from '@op/assets/svg/channel/cafe.svg';
import navergame from '@op/assets/svg/channel/navergame.svg';
import socialmedia from '@op/assets/svg/channel/socialmedia.svg';
import instagram from '@op/assets/svg/channel/instagram.svg';
import xiaohongshu from '@op/assets/svg/channel/xiaohongshu.svg';
import quora from '@op/assets/svg/channel/quora.svg';

import kwai from '@op/assets/svg/channel/kwai.svg';
import ruliweb from '@op/assets/svg/channel/ruliweb.svg';
import mi from '@op/assets/svg/channel/mi.svg';
import oppo from '@op/assets/svg/channel/oppo.svg';
import line from '@op/assets/svg/channel/line.svg';
import bilibili from '@op/assets/svg/channel/bilibili.svg';
import funcom from '@op/assets/svg/channel/funcom.svg';
import xbox from '@op/assets/svg/channel/xbox.svg';
import ps from '@op/assets/svg/channel/ps.svg';

import huya from '@op/assets/svg/channel/huya.svg';
import threedm from '@op/assets/svg/channel/3dm.svg';
import forumgamer from '@op/assets/svg/channel/forumgamer.svg';
import gamersky from '@op/assets/svg/channel/gamersky.svg';
import tieba from '@op/assets/svg/channel/tieba.svg';
import pathofexile from '@op/assets/svg/channel/pathofexile.svg';
import dcinside from '@op/assets/svg/channel/dcinside.svg';
import blackBox from '@op/assets/svg/channel/black_box.svg';
import Meta from '@op/assets/svg/channel/Meta.svg';
import Telegram from '@op/assets/svg/channel/Telegram.svg';
import kuaishou from '@op/assets/svg/channel/kuaishou.svg';

// marketing
import admob from '@op/assets/svg/channel/marketing/admob.svg';
import adsense from '@op/assets/svg/channel/marketing/adsense.svg';
import akane from '@op/assets/svg/channel/marketing/akane.svg';
import ameba from '@op/assets/svg/channel/marketing/ameba.svg';
import appleSearchAds from '@op/assets/svg/channel/marketing/apple_search_ads.svg';
import applovin from '@op/assets/svg/channel/marketing/applovin.svg';
import audienceNetwork from '@op/assets/svg/channel/marketing/audience_network.svg';
import bigoAds from '@op/assets/svg/channel/marketing/bigo_ads.svg';
import chartboost from '@op/assets/svg/channel/marketing/chartboost.svg';
import daum from '@op/assets/svg/channel/marketing/daum.svg';
import dtExchange from '@op/assets/svg/channel/marketing/dt_exchange.svg';
import googleAds from '@op/assets/svg/channel/marketing/google.svg';
import gunosy from '@op/assets/svg/channel/marketing/gunosy.svg';
import iMobile from '@op/assets/svg/channel/marketing/iMobile.svg';
import inmobi from '@op/assets/svg/channel/marketing/inmobi.svg';
import ironsource from '@op/assets/svg/channel/marketing/ironsource.svg';
import kwaiChinese from '@op/assets/svg/channel/marketing/kwaiChinese.svg';
import liftoff from '@op/assets/svg/channel/marketing/liftoff.svg';
import messenger from '@op/assets/svg/channel/marketing/messenger.svg';
import mintegral from '@op/assets/svg/channel/marketing/mintegral.svg';
import moloco from '@op/assets/svg/channel/marketing/moloco.svg';
import nate from '@op/assets/svg/channel/marketing/nate.svg';
import naver from '@op/assets/svg/channel/marketing/naver.svg';
import nend from '@op/assets/svg/channel/marketing/nend.svg';
import pangle from '@op/assets/svg/channel/marketing/pangle.svg';
import pinterest from '@op/assets/svg/channel/marketing/pinterest.svg';
import smartnews from '@op/assets/svg/channel/marketing/smartnews.svg';
import snapchat from '@op/assets/svg/channel/marketing/snapchat.svg';
import tapjoy from '@op/assets/svg/channel/marketing/tapjoy.svg';
import topbuzz from '@op/assets/svg/channel/marketing/topbuzz.svg';
import unityads from '@op/assets/svg/channel/marketing/unityads.svg';
import vkontakte from '@op/assets/svg/channel/marketing/vkontakte.svg';
import xPlatform from '@op/assets/svg/channel/marketing/x.svg';
import yahoo from '@op/assets/svg/channel/marketing/yahoo.svg';
import yahooJapan from '@op/assets/svg/channel/marketing/yahooJapan.svg';
import yandex from '@op/assets/svg/channel/marketing/yandex.svg';
import weibo from '@op/assets/svg/channel/weibo.svg';
import threads from '@op/assets/svg/channel/threads.svg';
import bluesky from '@op/assets/svg/channel/bluesky.svg';

import TextBubbles from '@/pages/home/components/TextBubbles';
import { forEach } from 'lodash-es';

const channel = {
  epgame: { img: epgame, name: 'Epgame' },
  steam: { img: steam, name: 'Steam' },
  twitch: { img: twitch, name: 'Twitch' },
  twitter: { img: twitter, name: 'X' },
  twitch_keyword: { img: twitch, name: 'Twitch_Keyword' },
  twitch_live: { img: twitch, name: 'Twitch Live' },
  vgtime: { img: vgtime, name: 'Vgtime' },
  facebook: { img: facebook, name: 'Facebook' },
  facebook_gaming: { img: facebookGaming, name: 'Facebook' },
  reddit: { img: reddit, name: 'Reddit' },
  metacritic: { img: metacritic, name: 'Metacritic' },
  youtube_keyword: { img: youtube, name: 'YouTube' },
  youtube: { img: youtube, name: 'YouTube' },
  youtube_live: { img: youtube, name: 'YouTube Live' },
  ytg: { img: youtube, name: 'YouTube' },
  youtube_gaming: { img: youtube_gaming, name: 'YouTube gaming' },
  opencritic: { img: opencritic, name: 'Opencritic' },
  'app store': { img: app_store, name: 'App Store' },
  'google play': { img: google_play, name: 'Google Play' },
  tiktok: { img: tiktok, name: 'TikTok' },
  tiktok_live: { img: tiktok, name: 'TikTok Live' },
  vk: { img: vk, name: 'Vk' },
  cafe: { img: cafe, name: 'Cafe' },
  navercafe: { img: cafe, name: 'Naver Cafe' },
  navergame: { img: navergame, name: 'Naver Game' },
  instagram: { img: instagram, name: 'Instagram' },
  discord: { img: discord, name: 'Discord' },
  taptap: { img: taptap, name: 'TapTap' },
  kwai: { img: kwai, name: 'Kwai' },
  ruliweb: { img: ruliweb, name: 'Ruliweb' },
  mi: { img: mi, name: 'Xiaomi Market' },
  oppo: { img: oppo, name: 'Oppo Store' },
  line: { img: line, name: 'Line' },
  bilibili: { img: bilibili, name: 'BiliBili' },
  'funcom forum': { img: funcom, name: 'Funcom' },
  funcom: { img: funcom, name: 'Funcom' },
  steam_community: { img: steam, name: 'Steam Community' },
  xbox: { img: xbox, name: 'Xbox' },
  playstation: { img: ps, name: 'Playstation' },
  huya: { img: huya, name: 'Huya' },
  '3dm': { img: threedm, name: '3dm' },
  forumgamer: { img: forumgamer, name: 'Forumgamer' },
  gamersky: { img: gamersky, name: 'gamersky' },
  pathofexile: { img: pathofexile, name: 'Path of Exile' },
  tieba: { img: tieba, name: 'Tieba' },
  douyin: { img: douyin, name: 'Douyin' },
  chzzk: { img: chzzk, name: 'Chzzk' },
  sooplive: { img: sooplive, name: 'Sooplive' },
  afreeca: { img: sooplive, name: 'Sooplive' },
  dcinside: { img: dcinside, name: 'Dcinside' },
  xiaoheihe: { img: blackBox, name: 'xiaoheihe' },
  xiaoheihe_store: { img: blackBox, name: 'xiaoheihe_store' },
  meta_store: { img: Meta, name: 'Meta' },
  twitch_liveroom: { img: twitch, name: 'Twitch Live' },
  xiaohongshu: { img: xiaohongshu, name: 'xiaohongshu' },
  quora: { img: quora, name: 'quora' },
  weibo: { img: weibo, name: 'Weibo' },
  threads: { img: threads, name: 'Threads' },
  bluesky: { img: bluesky, name: 'Bluesky' },
  kuaishou: { img: kuaishou, name: 'Kuaishou' },
  telegram: { img: Telegram, name: 'Telegram' },
  // marketing
};

const marktingChannel = {
  admob: { img: admob, name: 'Admob' },
  adsense: { img: adsense, name: 'AdSense' },
  akane: { img: akane, name: 'AkaNe' },
  'ameba(アメーバ)': { img: ameba, name: 'Ameba(アメーバ)' },
  'apple search ads': { img: appleSearchAds, name: 'Apple Search Ads' },
  applovin: { img: applovin, name: 'applovin' },
  'audience network': { img: audienceNetwork, name: 'Audience Network' },
  'audience_network': { img: audienceNetwork, name: 'Audience Network' },
  'bigoads': { img: bigoAds, name: 'BIGO Ads' },
  chartboost: { img: chartboost, name: 'Chartboost' },
  'daum': { img: daum, name: 'Daum(다음)' },
  'dt_exchange': { img: dtExchange, name: 'DT Exchange' },
  google: { img: googleAds, name: 'Google' },
  'gunosy(グノシー)': { img: gunosy, name: 'Gunosy(グノシー)' },
  'i-mobile': { img: iMobile, name: 'i-mobile' },
  inmobi: { img: inmobi, name: 'InMobi' },
  ironsource: { img: ironsource, name: 'ironSource' },
  'kwai 快手': { img: kwaiChinese, name: 'kwai 快手' },
  liftoff: { img: liftoff, name: 'Liftoff' },
  messenger: { img: messenger, name: 'Messenger' },
  'mobvista': { img: mintegral, name: 'Mintegral(Mobvista)' },
  moloco: { img: moloco, name: 'Moloco' },
  'nate(네이트)': { img: nate, name: 'Nate(네이트)' },
  'naver': { img: naver, name: 'NAVER(네이버)' },
  nend: { img: nend, name: 'Nend' },
  pangle: { img: pangle, name: 'Pangle' },
  pinterest: { img: pinterest, name: 'Pinterest' },
  'smartnews(スマートニュース)': {
    img: smartnews,
    name: 'SmartNews(スマートニュース)',
  },
  snapchat: { img: snapchat, name: 'Snapchat' },
  tapjoy: { img: tapjoy, name: 'Tapjoy' },
  topbuzz: { img: topbuzz, name: 'TopBuzz' },
  unity_ads: { img: unityads, name: 'UnityAds' },
  vkontakte: { img: vkontakte, name: 'Vkontakte' },
  x: { img: xPlatform, name: 'X' },
  'yahoo!': { img: yahoo, name: 'Yahoo!' },
  'yahoo! japan': { img: yahooJapan, name: 'Yahoo! Japan' },
  yandex: { img: yandex, name: 'Yandex' },
};

export type ChannelIconType = keyof typeof channel;

/**
 * TODO: 其他系统使用
 * 获取渠道名称和图标
 * @param channel_name
 * @param defaultImage
 * @param isMarketing 是否合并市场运营渠道
 * @returns {name} 渠道名称
 * @returns {img}  渠道图标
 * @returns {flag} 是否有图标，true：默认图标，false：有图标
 */
export function channelInfo(
  channel_name: ChannelIconType,
  defaultImage?: string,
  isMarketing = false,
): { name: string; img: string; flag?: boolean } {
  const key = channel_name?.toLocaleLowerCase?.();
  const searchChannel = isMarketing
    ? { ...channel, ...marktingChannel }
    : channel;
  const channelConfig = searchChannel[key as ChannelIconType];
  if (channelConfig) {
    return channelConfig;
  }
  return {
    img: defaultImage || socialmedia,
    name: channel_name,
    flag: true,
  };
}

/**
 * TODO: 其他系统使用
 * 渠道图标+提示文案
 * @param param0
 * @returns
 */
export default function ChannelLabel({
  channel_name,
  showText = true,
  className,
  iconClassName,
  textClassName,
  style = {},
  iconStyle = {},
  textStyle = {},
  textBubbleStyle = {},
  replaceText,
  defaultImage,
  isMarketing = false,
}: {
  channel_name: ChannelIconType;
  showText?: boolean;
  className?: string;
  iconClassName?: string;
  textClassName?: string;
  style?: React.CSSProperties;
  textStyle?: React.CSSProperties;
  textBubbleStyle?: React.CSSProperties;
  iconStyle?: React.CSSProperties;
  replaceText?: string | JSX.Element;
  defaultImage?: string;
  isMarketing?: boolean;
}) {
  const channel = channelInfo(channel_name, defaultImage, isMarketing);
  const img = channel.img;
  const name = channel.name;

  return (
    <div className={`${className} dbo-channellabel`} style={style}>
      <img
        style={iconStyle}
        src={img}
        className={`dbo-channellabel-icon ${iconClassName}`}
      />
      {showText && (
        // <span className={`dbo-channellabel-text ${textClassName}`}>
        //   {replaceText ? replaceText : name}
        // </span>
        <TextBubbles
          rowNum={1}
          style={textBubbleStyle}
          textStyle={textStyle}
          className={`dbo-channellabel-text ${textClassName}`}
          text={replaceText ? replaceText : name}
        />
      )}
    </div>
  );
}

export const dealwithChannelChartKey = (key: string) => {
  if (typeof key !== 'string') {
    return key;
  }
  return key.replace(/[^a-zA-Z0-9$_]/g, '_');
};

/**
 * 获取渠道的legendRich对象
 * @param width   显示的宽度
 * @param height  显示的高度
 * @param corsMode 是否跨域模式
 * @param isMarketing 是否合并市场运营渠道
 * @returns
 */
export function channelLegendRichInfo(
  width: number,
  height: number,
  corsMode = false,
  isMarketing = false,
  defaultImage: string = socialmedia,
) {
  const obj: { [key in string]?: any } = {};
  const searchChannel: typeof channel | (typeof channel & typeof marktingChannel) = isMarketing
    ? { ...channel, ...marktingChannel }
    : channel;
  forEach(searchChannel, ({ img }: { img: any }, key: string) => {
    const realKey = dealwithChannelChartKey(key);
    let image: string | HTMLImageElement = img;
    if (corsMode) {
      const imgEl = new Image();
      imgEl.crossOrigin = 'anonymous';
      imgEl.src = img;
      image = imgEl;
    }
    obj[realKey] = { height, width, backgroundColor: { image } };
  });
  // 添加默认图标配置
  const defaultKey = dealwithChannelChartKey('default');
  let defaultImg: string | HTMLImageElement = defaultImage;
  if (corsMode) {
    const imgEl = new Image();
    imgEl.crossOrigin = 'anonymous';
    imgEl.src = defaultImage;
    defaultImg = imgEl;
  }
  obj[defaultKey] = { height, width, backgroundColor: { image: defaultImg } };
  return obj;
}
